var map = {
	"./ArrowUpDown.svg": 477,
	"./CalenderIcon.svg": 478,
	"./Close.svg": 479,
	"./EW-RnR-banner.svg": 480,
	"./EW-logo-2.svg": 481,
	"./EW-logo.svg": 482,
	"./EW-module-banner.svg": 483,
	"./EW-welcome-banner.svg": 484,
	"./EngageWith.svg": 485,
	"./EngageWith_Logo.svg": 486,
	"./Logo.svg": 487,
	"./Notification-Payment-icon.svg": 488,
	"./RnR-setup-complete-bg.svg": 489,
	"./RnR-setup-complete-msteams.svg": 490,
	"./RnR-setup-complete-slack.svg": 491,
	"./Setup-suggestion.svg": 492,
	"./add-icon.svg": 493,
	"./all-activities-un-active.svg": 494,
	"./all-activities-un.svg": 495,
	"./all-activities.svg": 496,
	"./allowanceImg.svg": 497,
	"./analytics-un-active.svg": 498,
	"./analytics-un.svg": 499,
	"./analytics.svg": 500,
	"./anniversary-post-banner.svg": 501,
	"./announce_award.svg": 502,
	"./approveOrReject.svg": 503,
	"./award-post-bg.svg": 504,
	"./award_type_direct.svg": 505,
	"./award_type_poll.svg": 506,
	"./back-arrow.svg": 507,
	"./badge.svg": 368,
	"./bg-recognition.svg": 508,
	"./birthday-post-banner.svg": 509,
	"./bonus-banner.svg": 510,
	"./bonus-icon.svg": 511,
	"./bonus-logo.svg": 512,
	"./bonus-notification-icon.svg": 513,
	"./bonus-post-banner.svg": 514,
	"./bonus.svg": 515,
	"./bronze-medal.svg": 369,
	"./browse-templates.svg": 516,
	"./bx_export.svg": 517,
	"./calender.svg": 518,
	"./catalog-active.svg": 519,
	"./catalog-logo.svg": 520,
	"./catalog-un-active.svg": 521,
	"./catalog-un.svg": 522,
	"./catalog.svg": 523,
	"./certificate-logo.svg": 524,
	"./change-manager-for-team.svg": 370,
	"./channel_icon.svg": 525,
	"./chevron-left-transparent.svg": 526,
	"./chevron-right-transparent.svg": 527,
	"./circle-border.svg": 528,
	"./circle-small.svg": 529,
	"./circle-tick.svg": 530,
	"./clap.svg": 371,
	"./clock.svg": 531,
	"./clock_delayed.svg": 532,
	"./close-blue.svg": 533,
	"./close-red-big.svg": 534,
	"./close-red.svg": 535,
	"./closeBlue.svg": 536,
	"./coin-stack.svg": 537,
	"./coins.svg": 538,
	"./connection-green-icon.svg": 539,
	"./connection-icon.svg": 540,
	"./copy.svg": 541,
	"./coupon.svg": 542,
	"./default-user.svg": 543,
	"./deleteIcon.svg": 544,
	"./dislike.svg": 545,
	"./done.svg": 546,
	"./dropdown-dots.svg": 547,
	"./dropdown-search.svg": 548,
	"./duplicate-icon.svg": 549,
	"./eNPS.svg": 550,
	"./eNPSConfirm.svg": 372,
	"./eNPSImage.svg": 551,
	"./ea_empty.svg": 552,
	"./edit-blue-bg-icon.svg": 553,
	"./edit-blue-pencil.svg": 554,
	"./edit-blue.svg": 555,
	"./edit.svg": 556,
	"./editIcon.svg": 557,
	"./ellipse.svg": 558,
	"./emoji-glowing-star.svg": 559,
	"./emoji-people.svg": 560,
	"./employee-trophy.svg": 561,
	"./employeeAwardSidenavIcon.svg": 562,
	"./employee_award_splash_logo.svg": 563,
	"./empty-awardees.svg": 564,
	"./empty-department.svg": 373,
	"./empty-filter.svg": 374,
	"./empty-flag.svg": 188,
	"./empty-member.svg": 565,
	"./empty-rewards.svg": 566,
	"./empty-tnc.svg": 567,
	"./empty-user-analytics-table.svg": 568,
	"./empty.svg": 569,
	"./emptyOrg.svg": 570,
	"./empty_location.svg": 375,
	"./engageWith-circle.svg": 571,
	"./engagement-rate.svg": 376,
	"./engagewith-certificate.svg": 572,
	"./enhanceAI-blue.svg": 573,
	"./enhanceAI.svg": 574,
	"./enps-icon-active.svg": 575,
	"./enps-icon.svg": 576,
	"./error.svg": 577,
	"./ew-logo-transparent.svg": 578,
	"./ewlogo.svg": 579,
	"./extend_voting_deadline.svg": 580,
	"./eye-invisible.svg": 581,
	"./eye-visible.svg": 582,
	"./eye.svg": 583,
	"./faq.svg": 584,
	"./feedback-disabled-banner.svg": 585,
	"./feedback-icon.svg": 586,
	"./feedback-logo.svg": 587,
	"./feedback-shared.svg": 377,
	"./feedback.svg": 588,
	"./file-certificate.svg": 589,
	"./file.svg": 590,
	"./filter.svg": 591,
	"./flag-man.svg": 592,
	"./folderIcon.svg": 593,
	"./gift-box-red.svg": 594,
	"./gift-card-voucher.svg": 595,
	"./gift-card.svg": 378,
	"./gift-money.svg": 379,
	"./giftTag.svg": 596,
	"./giftcard-background.svg": 597,
	"./gold-medal.svg": 380,
	"./green-round-tick.svg": 598,
	"./green-tick-hollow.svg": 599,
	"./green-tick.svg": 600,
	"./grey-round-cross.svg": 601,
	"./group-icon.svg": 602,
	"./group.svg": 272,
	"./group_selected.svg": 603,
	"./home-icon.svg": 604,
	"./hour-glass-loading.svg": 605,
	"./hourglass.svg": 606,
	"./ic-avatar.svg": 607,
	"./ic-bulk-update.svg": 608,
	"./ic-clapping-hands.svg": 609,
	"./ic-close-rounded.svg": 610,
	"./ic-copy.svg": 611,
	"./ic-invite-users.svg": 612,
	"./ic-map-teams.svg": 613,
	"./ic-recognition-success.svg": 614,
	"./ic-upload.svg": 615,
	"./ic_round-plus.svg": 616,
	"./icon-email-rounded.svg": 617,
	"./icon-forward.svg": 618,
	"./icon-google.svg": 619,
	"./icon-microsoft.svg": 620,
	"./icon-ms-teams.svg": 381,
	"./icon-open-channel.svg": 621,
	"./icon-poll.svg": 622,
	"./icon-slack.svg": 382,
	"./ignore.svg": 623,
	"./imp_note.svg": 624,
	"./inactive.svg": 383,
	"./info-blue.svg": 625,
	"./info-grey-filled.svg": 626,
	"./info-grey.svg": 627,
	"./info-purple.svg": 628,
	"./info-white-filled.svg": 629,
	"./leaderboard-active.svg": 630,
	"./leaderboard-logo.svg": 631,
	"./leaderboard-un-active.svg": 632,
	"./leaderboard-un.svg": 633,
	"./leaderboard.svg": 634,
	"./like.svg": 635,
	"./lock.svg": 636,
	"./mail_delayed.svg": 637,
	"./manager-mapping-logo.svg": 638,
	"./manager_sm.svg": 639,
	"./member_close.svg": 640,
	"./more-details.svg": 641,
	"./ms-teams.svg": 642,
	"./my-activities-active.svg": 643,
	"./my-activities-un-active.svg": 644,
	"./my-activities-un.svg": 645,
	"./my-activities.svg": 646,
	"./no-audit-logs.svg": 384,
	"./no-feedback.svg": 647,
	"./no-suggestions.svg": 648,
	"./noTasks.svg": 649,
	"./notification-bell.svg": 650,
	"./notification.svg": 651,
	"./notifications-selected.svg": 652,
	"./noun-discussion.svg": 653,
	"./noun-leaderboard.svg": 654,
	"./noun-party.svg": 655,
	"./noun-reward.svg": 656,
	"./org-health-logo.svg": 657,
	"./organization-active.svg": 658,
	"./organization-un-active.svg": 659,
	"./organization-un.svg": 660,
	"./organization.svg": 661,
	"./outplay-logo.svg": 662,
	"./overflow-menu.svg": 663,
	"./paymentMethod.svg": 664,
	"./payments-selected.svg": 665,
	"./payments.svg": 666,
	"./pick_awardee.svg": 667,
	"./plus.svg": 668,
	"./primaryCard-tag.svg": 669,
	"./profile.svg": 670,
	"./pulse-active.svg": 671,
	"./pulse-un-active.svg": 672,
	"./pulse-un.svg": 673,
	"./pulse.svg": 674,
	"./pulseSurvey.svg": 675,
	"./question-book.svg": 676,
	"./quote.svg": 677,
	"./radioButtonNotSelected.svg": 303,
	"./radioButtonSelected.svg": 304,
	"./recognition-not-configured.svg": 678,
	"./recognitionImg.svg": 679,
	"./red-cross.svg": 680,
	"./red-round-cross.svg": 681,
	"./red-thumbsup.svg": 682,
	"./redeem-active.svg": 683,
	"./redeem-points.svg": 684,
	"./redeem-un-active.svg": 685,
	"./redeem-un.svg": 686,
	"./redeem.svg": 687,
	"./redemption-config-banner.svg": 688,
	"./redemption-failed-user.svg": 689,
	"./redemption.svg": 690,
	"./redirect-slack.svg": 691,
	"./refresh.svg": 692,
	"./reminder-disabled-icon.svg": 693,
	"./reminder-icon.svg": 694,
	"./retry.svg": 695,
	"./rewards-and-recognitions-logo.svg": 696,
	"./rewards-recognitions-logo.svg": 697,
	"./rewards_recognitions_logo.svg": 698,
	"./rocket.svg": 699,
	"./search-audience.svg": 700,
	"./search.svg": 701,
	"./send_voting_reminder.svg": 702,
	"./separator-dot.svg": 703,
	"./setting.svg": 704,
	"./settings-selected.svg": 705,
	"./setup-feedback.svg": 706,
	"./show-feedback-message.svg": 707,
	"./signout.svg": 708,
	"./silver-medal.svg": 385,
	"./slack.svg": 709,
	"./special-rewards-logo.svg": 710,
	"./star-coins.svg": 711,
	"./stopIcon.svg": 712,
	"./subcription_cancelled_screen.svg": 713,
	"./success-checkmark.svg": 714,
	"./success.svg": 715,
	"./suggestion-analytics.svg": 386,
	"./suggestion-box-icon-otheractions.svg": 716,
	"./suggestion-box-icon.svg": 717,
	"./suggestion-box.svg": 718,
	"./suggestions-disabled.svg": 719,
	"./survey-sent.svg": 720,
	"./tape.svg": 387,
	"./tick.svg": 721,
	"./touch.svg": 722,
	"./user-redeem-points.svg": 723,
	"./users.svg": 724,
	"./validity.svg": 388,
	"./vote-icon.svg": 725,
	"./wallet-icon.svg": 726,
	"./warning-purple.svg": 727,
	"./warning-red.svg": 728,
	"./warning-yellow.svg": 729,
	"./warning.svg": 730,
	"./wright-tick.svg": 731,
	"./wrong-tick.svg": 732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;